module.exports = __webpack_public_path__ + "img/semitrailerFrontLeft.33a0fbab.svg";